import { Instance } from '../lib/axiosInterceptor';

// Phase 6: Central billing endpoints aligned with latest backend routes.
const inFlightRequests = new Map();
const USERS_API_BASE = '/api/v1/users';

const withInFlightDedup = (key, requestFactory) => {
  if (inFlightRequests.has(key)) {
    return inFlightRequests.get(key);
  }

  const requestPromise = requestFactory().finally(() => {
    inFlightRequests.delete(key);
  });
  inFlightRequests.set(key, requestPromise);
  return requestPromise;
};

export const billingService = {
  // Phase 6: Dedup bootstrap GET calls to avoid duplicate initial fetches.
  getProfile: () => withInFlightDedup('billing_profile', () => Instance.get(`${USERS_API_BASE}/billing/profile`)),
  getCards: () => withInFlightDedup('billing_get_cards', () => Instance.get(`${USERS_API_BASE}/billing/getCards`)),
  getBillingHistory: () => withInFlightDedup('billing_history', () => Instance.get(`${USERS_API_BASE}/billing/getBillingHistory`)),
  addCard: ({ paymentMethodId, isPrimary }) => Instance.post(`${USERS_API_BASE}/billing/addCard`, { paymentMethodId, isPrimary }),
  makeCardPrimary: ({ paymentMethodId }) => Instance.post(`${USERS_API_BASE}/billing/makeCardPrimary`, { paymentMethodId }),
  removeCard: ({ paymentMethodId }) => Instance.post(`${USERS_API_BASE}/billing/removeCard`, { paymentMethodId }),
  addFunds: ({ amount }) => Instance.post(`${USERS_API_BASE}/billing/add-funds`, { amount }),
  addTgFunds: ({ amount }) => Instance.post(`${USERS_API_BASE}/billing/add-tg-funds`, { amount }),
  updateAutoRecharge: ({ amount }) => Instance.post(`${USERS_API_BASE}/billing/updateAutoRechargeWith`, { amount }),
  updateTgAutoRecharge: ({ amount }) => Instance.post(`${USERS_API_BASE}/billing/updateTgAutoRechargeWith`, { amount }),
  updateBalanceLowerThan: ({ amount }) => Instance.post(`${USERS_API_BASE}/billing/updateBalanceLowerThan`, { amount }),
  updateTgBalanceLowerThan: ({ amount }) => Instance.post(`${USERS_API_BASE}/billing/updateTgBalanceLowerThan`, { amount }),
  createIntent: () => Instance.post(`${USERS_API_BASE}/create-intent`),
};
